import { createAuthClient } from 'better-auth/client';

export const authClient = createAuthClient({ basePath: '/api/auth' });

export async function signInWithGoogle(callbackURL = window.location.href): Promise<void> {
  const result = await authClient.signIn.social({ provider: 'google', callbackURL });
  if (result.error) throw new Error(result.error.message ?? 'Google sign-in could not start.');
}

export async function signOutGoogle(): Promise<void> {
  const result = await authClient.signOut();
  if (result.error) throw new Error(result.error.message ?? 'Google sign-out could not be completed.');
}
